<template>
  <div>
    <h1>Novo Parceiro</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("parceiros", ["parceiro"]),
  },
  methods: {
    ...mapActions("parceiros", ["ActionNewparceiro"]),
    loadData(id) {
      this.$router.push({ name: "parceiros_edit", params: { id: id } });
    },
  },
  async created() {
    this.ActionNewparceiro();
  },
};
</script>

<style></style>
